import React from 'react';

import { Group, Text } from '@mantine/core';
import { WorkoutTemplateList } from 'types';

interface TemplateNameCellProps {
  template: WorkoutTemplateList;
  onPreview: (template: WorkoutTemplateList) => void;
}

const TemplateNameCell = ({ template, onPreview }: TemplateNameCellProps): JSX.Element => (
  <Group spacing='xs' noWrap>
    <Text
      onClick={() => onPreview(template)}
      weight='bold'
      underline
      sx={{ cursor: 'pointer', width: 'fit-content' }}
    >
      {template.name}
    </Text>
  </Group>
);

export default TemplateNameCell;
